import { ThemeTokens } from '@acp/core-ui';
import { HStack } from '@chakra-ui/react';

function NavBarContainer({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <HStack
            w="full"
            bgColor="white"
            role="banner"
            px={ThemeTokens.Defaults.px}
            spacing={{ base: 6, md: 7, xl: 10 }}
            borderBottomWidth={1}
            h={[16, null, 20]}
            borderBottomColor={ThemeTokens.Defaults.borderColor}
        >
            {children}
        </HStack>
    );
}

export { NavBarContainer };
